import { Participant } from '@/types'
import { Avatar } from 'flowbite-react'
import DiscordIcon from '@/public/images/icons/discord-black.svg'
import Image from 'next/image'
import { participantDisplayName } from '@/utils/participant'

const ParticipantProfile = ({
  participant,
  email,
}: {
  participant: Participant
  email?: string
}) => {
  return (
    <Avatar img={participant.avatar_url} rounded size="lg">
      <div className="space-y-1">
        <div>
          {participantDisplayName(participant)}
          {email && email === participant.email && ' (you)'}
        </div>

        {participant.social_network.toLowerCase() == 'discord' &&
          participant.social_network_username &&
          participant.social_network_username !== 'unspecified' && (
            <div className="text-xs text-gray-500 flex">
              <Image src={DiscordIcon} alt="Discord" width={20} height={20} />

              <span className="ml-1 pt-[1px]">
                {participant.social_network_username.length > 20
                  ? `${participant.social_network_username.slice(0, 18)}...`
                  : participant.social_network_username}
              </span>
            </div>
          )}

        <div className="text-xs text-gray-500">@{participant.username}</div>
        {/* <div className="text-xs text-gray-500">{participant.email}</div> */}
      </div>
    </Avatar>
  )
}

export default ParticipantProfile
